export default __webpack_public_path__ + "static/media/AudioVisual2.7c3354a8.mp4";